exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading p[data-v-348b0280]{text-align:justify;letter-spacing:.5px}", ""]);

// exports
